import J7Detail from './J7Detail';

export default J7Detail;
